/* Explicit main-PDP size choice. Event driven: no observers, polling or initial ID clearing.
   Native payment output stays mounted in its original form. Never programmatically click a wallet. */
(function () {
  'use strict';
  if (window.MipSizeChoice) return;
  var records = new Map();
  var openRecord = null;
  var synchronising = false;
  var fallbackMessages = {
    choose_size: 'Choose your size', available_help: 'Select an available size to continue.',
    select_size: 'Select your size', select_first: 'Please select an available size.',
    none_available: 'No sizes are available for the current options.', unavailable: 'This size is currently unavailable',
    chosen: 'Selected size:', close: 'Close size selection', cancel: 'Keep shopping',
    add_confirm: 'Add to My Bag', buy_confirm: 'Continue to Buy now',
    payment_ready: 'Size selected. Please use the payment button to continue.',
    review_required: 'Please review the required options on the product page before continuing.'
  };
  function msg(r, key) { return r.data.messages[key] || fallbackMessages[key] || key; }
  function setAttr(el, key, val) { if (el && el.getAttribute(key) !== String(val)) el.setAttribute(key, String(val)); }
  function setHidden(el, hidden) { if (el && el.hidden !== hidden) el.hidden = hidden; }
  function setDisabled(el, disabled) { if (el && el.disabled !== disabled) el.disabled = disabled; }
  function byId(r, id) { return r.variants.get(String(id)); }
  function master(r) { return r.form.querySelector('[name="id"]'); }
  function current(r) { return byId(r, master(r) && master(r).value) || byId(r, r.data.initialId); }
  function valid(r) {
    var variant = byId(r, r.chosenId);
    return !!(variant && variant.available && master(r) && String(master(r).value) === r.chosenId);
  }
  function candidate(r, value) {
    var reference = current(r);
    if (!reference) return null;
    return r.data.variants.find(function (v) {
      return String(v.options[r.data.sizeIndex]) === value && v.options.every(function (option, index) {
        return index === r.data.sizeIndex || option === reference.options[index];
      });
    });
  }
  function options(r) { return r.templates.map(function (t) { return { template: t, variant: candidate(r, t.dataset.mipChoiceSize) }; }); }
  function available(r) { return options(r).filter(function (o) { return o.variant && o.variant.available; }); }
  function owners(r) { return Array.from(document.querySelectorAll('[data-mip-choice-product="' + r.id + '"]')); }
  function formFor(r, suffix) { return document.getElementById('product-form' + (suffix || '') + '-' + r.id); }
  function mainButton(r) { return r.form.querySelector('[data-btn-addtocart], [name="add"]'); }
  function busy(button) { return !!(button && (button.classList.contains('is-loading') || button.classList.contains('loading') || button.getAttribute('aria-busy') === 'true')); }
  function update(r) {
    if (!r.root.isConnected) return;
    var isValid = valid(r), hasAvailable = available(r).length > 0;
    owners(r).forEach(function (owner) {
      setAttr(owner, 'data-mip-choice-state', isValid ? 'chosen' : 'pending');
      owner.querySelectorAll('[data-mip-choice-wallet]').forEach(function (host) {
        setHidden(host, !isValid);
        if (host.inert !== !isValid) host.inert = !isValid;
      });
      owner.querySelectorAll('[data-mip-choice-buy]').forEach(function (button) { setHidden(button, isValid); setDisabled(button, !hasAvailable); });
      owner.querySelectorAll('[name="add"]').forEach(function (button) {
        if (button.type !== 'submit') button.type = 'submit';
        if (!busy(button)) setDisabled(button, !hasAvailable);
      });
    });
    r.root.querySelectorAll('[data-mip-choice-tiles="' + r.id + '"] [data-mip-choice-size]').forEach(function (tile) {
      var v = candidate(r, tile.dataset.mipChoiceSize), selected = isValid && v && v.id === r.chosenId;
      setDisabled(tile, !(v && v.available));
      tile.classList.toggle('is-unavailable', !(v && v.available));
      tile.classList.toggle('is-selected', !!selected);
      setAttr(tile, 'aria-pressed', !!selected);
    });
    var sticky = document.querySelector('[data-msab-root][data-product-id="' + r.id + '"]');
    if (sticky) {
      var sb = sticky.querySelector('[data-msab-add]');
      if (!busy(sb)) {
        setDisabled(sb, !hasAvailable);
        var caption = sticky.querySelector('[data-msab-btn-text]');
        var label = hasAvailable ? ((window.variantStrings && window.variantStrings.addToCart) || 'Add to My Bag') : ((window.variantStrings && window.variantStrings.soldOut) || 'Sold out');
        if (caption && caption.textContent.trim() !== label) caption.textContent = label;
      }
    }
    if (r.dialog && r.dialog.open) refreshDialog(r);
  }
  function quantities(r) {
    return Array.from(r.root.querySelectorAll('input[name="quantity"]')).filter(function (input) {
      return input.form === r.form || input.form === formFor(r, '-sticky') || input.dataset.product === r.id;
    });
  }
  function commit(r, value) {
    var v = candidate(r, value);
    if (!v || !v.available) return false;
    synchronising = true;
    r.chosenId = v.id;
    var originalQuantities = quantities(r);
    var visibleQuantity = originalQuantities.find(function (input) { return input.offsetParent !== null; }) || originalQuantities[0];
    var quantity = Number(visibleQuantity && visibleQuantity.value) || Number(v.minimum) || 1;
    var min = Number(v.minimum) || 1, step = Number(v.increment) || 1;
    var maximum = Number(v.maximum) > 0 ? Number(v.maximum) : Infinity;
    if (v.inventory_management && v.inventory_policy !== 'continue' && v.inventory_quantity > 0) maximum = Math.min(maximum, v.inventory_quantity);
    quantity = Math.max(min, Math.min(maximum, quantity));
    quantity = min + Math.floor((quantity - min) / step) * step;
    originalQuantities.forEach(function (input) {
      setAttr(input, 'min', min); setAttr(input, 'step', step);
      if (Number.isFinite(maximum)) setAttr(input, 'max', maximum); else if (input.hasAttribute('max')) input.removeAttribute('max');
      setAttr(input, 'data-price', v.price);
      if (v.inventory_management) setAttr(input, 'data-inventory-quantity', v.inventory_quantity);
      else input.removeAttribute('data-inventory-quantity');
      setAttr(input, 'data-available', v.inventory_policy === 'continue');
      if (String(input.value) !== String(quantity)) input.value = quantity;
      setDisabled(input, false); input.removeAttribute('aria-disabled');
      var parent = input.closest('quantity-input');
      if (parent) { parent.classList.remove('disabled'); parent.querySelectorAll('.btn-quantity').forEach(function (button) { setDisabled(button, false); }); }
    });
    var changed = [];
    [r.form, formFor(r, '-installment'), formFor(r, '-sticky')].forEach(function (form) {
      if (!form) return;
      var input = form.querySelector('[name="id"]');
      if (input) { input.value = v.id; changed.push(input); }
    });
    var sticky = document.querySelector('[data-msab-root][data-product-id="' + r.id + '"] [data-msab-id]');
    if (sticky) sticky.value = v.id;
    var add = mainButton(r);
    if (add) {
      setAttr(add, 'data-inventory-quantity', v.inventory_management ? v.inventory_quantity : '');
      setAttr(add, 'data-available', v.inventory_policy === 'continue');
      setDisabled(add, false);
    }
    // One explicit transition. Never dispatch another change in response to these events.
    changed.forEach(function (input) { input.dispatchEvent(new Event('change', { bubbles: true })); });
    r.root.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: v, productId: r.id } }));
    synchronising = false;
    updatePriceCaption(r, v, quantity);
    update(r);
    return valid(r);
  }
  function updatePriceCaption(r, v, quantity) {
    var add = mainButton(r), label = window.variantStrings && window.variantStrings.addToCart;
    if (!add || busy(add)) return;
    if (window.subtotal && window.subtotal.show && window.subtotal.style === '2' && window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var text = document.createElement('span');
      text.innerHTML = window.Shopify.formatMoney(v.price * quantity, window.money_format);
      label = String(window.subtotal.text || '').replace('[value]', text.textContent);
    } else if (v.inventory_management && v.inventory_quantity <= 0 && v.inventory_policy === 'continue') {
      label = (window.variantStrings && window.variantStrings.preOrder) || label;
    }
    if (label && add.textContent.trim() !== label.trim()) add.textContent = label;
  }
  function element(tag, className, text) {
    var el = document.createElement(tag); if (className) el.className = className;
    if (text !== undefined) el.textContent = text; return el;
  }
  function ensureDialog(r) {
    if (r.dialog) return;
    var dialog = element('dialog', 'mip-choice-dialog');
    dialog.id = 'MipChooseSize-' + r.id;
    setAttr(dialog, 'aria-labelledby', dialog.id + '-title');
    setAttr(dialog, 'aria-describedby', dialog.id + '-help');
    var header = element('div', 'mip-choice-dialog__header');
    var title = element('h2', '', msg(r, 'choose_size')); title.id = dialog.id + '-title'; title.tabIndex = -1;
    var close = element('button', 'mip-choice-close', '×'); close.type = 'button'; close.setAttribute('aria-label', msg(r, 'close'));
    header.append(title, close);
    var product = element('p', 'mip-choice-product', r.data.title);
    var help = element('p', 'mip-choice-help', msg(r, 'available_help')); help.id = dialog.id + '-help';
    var grid = element('div', 'mip-choice-tiles'); setAttr(grid, 'data-mip-choice-dialog-grid', r.id); grid.setAttribute('role', 'group'); grid.setAttribute('aria-label', msg(r, 'select_size'));
    var status = element('p', 'mip-choice-status'); status.setAttribute('role', 'status');
    var confirm = element('button', 'mip-choice-confirm'); confirm.type = 'button'; confirm.disabled = true;
    var cancel = element('button', 'mip-choice-cancel', msg(r, 'cancel')); cancel.type = 'button';
    dialog.append(header, product, help, grid, status, confirm, cancel);
    document.body.appendChild(dialog);
    r.dialog = dialog; r.dialogGrid = grid; r.status = status; r.confirm = confirm; r.title = title;
    close.addEventListener('click', function () { dismiss(r); }); cancel.addEventListener('click', function () { dismiss(r); });
    dialog.addEventListener('cancel', function (e) { e.preventDefault(); dismiss(r); });
    dialog.addEventListener('click', function (e) {
      if (e.target !== dialog) return;
      var b = dialog.getBoundingClientRect();
      if (e.clientX < b.left || e.clientX > b.right || e.clientY < b.top || e.clientY > b.bottom) dismiss(r);
    });
    dialog.addEventListener('close', function () {
      if (!dialog.open && (!openRecord || openRecord === r)) {
        document.documentElement.classList.remove('mip-choice-dialog-open');
        if (openRecord === r) openRecord = null;
      }
    });
    confirm.addEventListener('click', function () {
      if (!valid(r)) { r.status.textContent = msg(r, 'select_first'); return; }
      var kind = r.intent;
      dismiss(r, false);
      if (kind === 'buy') {
        var target = r.paymentTarget || r.form.querySelector('.productView-payment');
        if (target && target.isConnected) {
          target.scrollIntoView({ block: 'center', behavior: 'auto' });
          target.setAttribute('tabindex', '-1'); target.focus({ preventScroll: true });
        }
        // Do not move, clone, submit or click the native payment component.
      } else sendAdd(r);
    });
  }
  function refreshDialog(r) {
    var opts = available(r);
    var signature = opts.map(function (o) { return o.variant.id; }).join(',');
    if (signature !== r.dialogSignature) {
      r.dialogSignature = signature;
      var fragment = document.createDocumentFragment();
      opts.forEach(function (o) {
        var tile = o.template.cloneNode(true); tile.removeAttribute('id'); tile.disabled = false;
        tile.classList.remove('is-unavailable', 'is-selected'); tile.removeAttribute('title');
        fragment.appendChild(tile);
      });
      r.dialogGrid.replaceChildren(fragment);
    }
    r.dialogGrid.querySelectorAll('[data-mip-choice-size]').forEach(function (tile) {
      var v = candidate(r, tile.dataset.mipChoiceSize), isSelected = valid(r) && v && v.id === r.chosenId;
      tile.classList.toggle('is-selected', !!isSelected); setAttr(tile, 'aria-pressed', !!isSelected);
    });
    setDisabled(r.confirm, !valid(r));
    r.confirm.textContent = msg(r, r.intent === 'buy' ? 'buy_confirm' : 'add_confirm');
    var selection = r.dialogGrid.querySelector('[aria-pressed="true"]');
    r.status.textContent = !opts.length ? msg(r, 'none_available') : selection ? msg(r, 'chosen') + ' ' + selection.textContent.replace(/\s+/g, ' ').trim() : msg(r, 'select_first');
  }
  function open(r, intent, trigger) {
    if (!valid(r)) { r.chosenId = ''; update(r); }
    if (openRecord && openRecord !== r) dismiss(openRecord);
    ensureDialog(r); r.intent = intent; r.trigger = trigger || mainButton(r);
    r.paymentTarget = trigger && trigger.closest('.productView-payment') || r.form.querySelector('.productView-payment');
    refreshDialog(r);
    if (typeof r.dialog.showModal !== 'function') {
      var picker = r.root.querySelector('[data-mip-choice-tiles]');
      if (picker) { picker.scrollIntoView({ block: 'center' }); picker.querySelector('button:not(:disabled)')?.focus(); }
      return;
    }
    document.dispatchEvent(new CustomEvent('mip:surface:open', { detail: { surface: 'size-choice', owner: r.dialog } }));
    if (!r.dialog.open) r.dialog.showModal();
    openRecord = r;
    document.documentElement.classList.add('mip-choice-dialog-open');
    r.title.focus({ preventScroll: true });
  }
  function dismiss(r, focusBack) {
    if (!r.dialog || !r.dialog.open) return;
    r.dialog.close();
    document.documentElement.classList.remove('mip-choice-dialog-open');
    if (openRecord === r) openRecord = null;
    if (focusBack !== false && r.trigger && r.trigger.isConnected) r.trigger.focus({ preventScroll: true });
  }
  function sendAdd(r) {
    var button = mainButton(r);
    if (!valid(r)) { open(r, 'add', button); return; }
    if (!button || busy(button) || button.disabled) return;
    // Retain the theme's own validation and cart engine. No new cart request is created here.
    button.click();
  }
  function recordFor(target) {
    if (!target || !target.closest) return null;
    var scope = target.closest('[data-mip-choice-product], [data-mip-choice-tiles], [data-mip-choice-dialog-grid]');
    if (scope) return records.get(scope.dataset.mipChoiceProduct || scope.dataset.mipChoiceTiles || scope.dataset.mipChoiceDialogGrid);
    var sticky = target.closest('[data-msab-root][data-product-id]');
    if (sticky) return records.get(String(sticky.dataset.productId)) || null;
    var form = target.form || target.closest('form');
    if (form) {
      return Array.from(records.values()).find(function (r) { return form === r.form || form === formFor(r, '-sticky'); }) || null;
    }
    return null;
  }
  function stop(e) { e.preventDefault(); e.stopImmediatePropagation(); }
  function interceptClick(e) {
    var target = e.target && e.target.closest ? e.target : null;
    if (!target) return;
    var r = recordFor(target);
    if (!r || !r.root.isConnected) return;
    var tile = target.closest('[data-mip-choice-size]');
    if (tile) {
      stop(e);
      if (e.isTrusted && !tile.disabled) commit(r, tile.dataset.mipChoiceSize);
      return;
    }
    var buy = target.closest('[data-mip-choice-buy]');
    if (buy) { stop(e); if (!buy.disabled) open(r, 'buy', buy); return; }
    var mobileAdd = target.closest('[data-msab-add]');
    if (mobileAdd) {
      stop(e);
      if (!mobileAdd.disabled) {
        if (valid(r)) sendAdd(r); else { update(r); open(r, 'add', mobileAdd); }
      }
      return;
    }
    var add = target.closest('[data-btn-addtocart], [name="add"]');
    if (add) {
      if (!valid(r)) { stop(e); update(r); open(r, 'add', add); }
      else if (add.form !== r.form) { stop(e); sendAdd(r); }
      return;
    }
    if (target.closest('.productView-payment') && !valid(r)) { stop(e); update(r); open(r, 'buy', target); }
  }
  // Window capture intercepts a user action before delegated theme handlers.
  window.addEventListener('click', interceptClick, true);
  window.addEventListener('submit', function (e) {
    var r = recordFor(e.target);
    if (!r) return;
    if (!valid(r)) { stop(e); update(r); open(r, 'add', mainButton(r)); }
    else if (e.target !== r.form) { stop(e); sendAdd(r); }
  }, true);
  document.addEventListener('change', function (e) {
    if (synchronising) return;
    var target = e.target, r = recordFor(target);
    if (!r) {
      r = Array.from(records.values()).find(function (entry) { return entry.root.contains(target); });
    }
    if (!r || !target.matches('[name="id"], select[data-option-position], variant-selects select, variant-radios input')) return;
    if (!valid(r)) { r.chosenId = ''; update(r); }
  });
  function init(scope) {
    (scope || document).querySelectorAll('[data-mip-size-choice-data]').forEach(function (node) {
      var data;
      try { data = JSON.parse(node.textContent); } catch (error) { return; }
      var id = String(data.productId), form = document.getElementById('product-form-' + id);
      var root = node.closest('.product-details');
      if (!form || !root || !Array.isArray(data.variants)) return;
      var old = records.get(id);
      if (old && old.root === root) return;
      if (old) { dismiss(old, false); if (old.dialog) old.dialog.remove(); }
      var grid = root.querySelector('[data-mip-choice-tiles="' + id + '"]');
      if (!grid) {
        var template = document.getElementById('MipSizeChoiceTiles-' + id);
        if (!template) return;
        var fallback = element('div', 'mip-choice-picker');
        fallback.appendChild(element('p', 'size-fit-label', data.messages.select_size));
        fallback.appendChild(template.content.cloneNode(true)); form.prepend(fallback);
        grid = fallback.querySelector('[data-mip-choice-tiles]');
      }
      var record = { id: id, data: data, root: root, form: form, chosenId: '', dialog: null, templates: Array.from(grid.querySelectorAll('[data-mip-choice-size]')).map(function (tile) { return tile.cloneNode(true); }) };
      record.variants = new Map(data.variants.map(function (v) { v.id = String(v.id); return [v.id, v]; }));
      records.set(id, record);
      update(record);
    });
  }
  window.MipSizeChoice = {
    allow: function (form, trigger) {
      var r = recordFor(form);
      if (!r) return false;
      if (!valid(r)) { open(r, 'add', trigger || mainButton(r)); return false; }
      if (form !== r.form) { sendAdd(r); return false; }
      return true;
    },
    refresh: function (id) {
      var r = records.get(String(id));
      if (!r || !r.root.isConnected) { init(); r = records.get(String(id)); }
      if (r && r.root.isConnected) { update(r); return true; }
      return false;
    },
    add: function (id, trigger) {
      var r = records.get(String(id));
      if (!r || !r.root.isConnected) { init(); r = records.get(String(id)); }
      if (!r) return false;
      if (valid(r)) sendAdd(r); else open(r, 'add', trigger);
      return true;
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }, { once: true });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    records.forEach(function (r, id) {
      if (e.target.contains(r.root)) { dismiss(r, false); if (r.dialog) r.dialog.remove(); records.delete(id); }
    });
  });
  // A mobile browser can restore this document from its back/forward cache.
  // Reconcile existing records without duplicating listeners or clearing a valid choice.
  window.addEventListener('pageshow', function () { init(); records.forEach(function (r) { update(r); }); });
  window.addEventListener('pagehide', function () { if (openRecord) dismiss(openRecord, false); });
})();
